import { Link } from "best-common-react";
import styled from "styled-components";

export const ModalBodyText = styled.div`
  color: ${props => props.theme.modal.body.fontColor};
  font-size: 0.87rem;
`;

export const ModalBodyHintText = styled.div`
  color: ${props => props.theme.colors.slate};
  font-size: 0.6875rem;
  font-style: italic;
  margin-bottom: 1rem;
`;

export const BulkUpdateCheckboxesHorizontalContainer = styled.div`
  display: flex;
  justify-content: start;
  margin-top: 1rem;
  flex-wrap: wrap;
`;
export const BulkUpdateCheckboxesVerticalContainer = styled.div`
  display: flex;
  justify-content: start;
  flex-flow: column wrap;
  max-height: 150px;
`;

const CheckboxWrapper = styled.div`
  display: flex;
  margin-top: 1rem;
  color: ${props => props.theme.checkbox.labelColor};
  font-size: 0.75rem;
`;

export const BulkUpdateCheckboxHorizontalWrapper = styled(CheckboxWrapper)`
  flex-flow: column;
  align-items: center;
  width: 60px;
  text-align: center;
`;

export const BulkUpdateCheckboxVerticalWrapper = styled(CheckboxWrapper)`
  display: flex;
  flex-flow: row;
`;

// TODO: Remove margin-top - parent containers should handle spacing instead
export const WidgetWrapper = styled.div`
  margin-top: var(--spacing-m);
  padding: var(--spacing-m) var(--spacing-l);
  border-radius: var(--spacing-s);
  border: solid 1px var(--color-outline-variant);
  background-color: var(--color-surface);
  color: var(--color-on-surface-low);
`;

export const CenteredRow = styled.div`
  display: flex;
  align-items: center;
`;

export const SpacedRow = styled(CenteredRow)`
  justify-content: space-between;
`;

export const FlexRow = styled.div`
  display: flex;
  > div:not(:last-child),
  button:not(:last-child) {
    margin-right: 0.5rem;
  }
`;

export const Title = styled.div`
  color: var(--color-on-surface-low);
  font-size: var(--font-size-medium);
  font-weight: 400;
  margin-bottom: var(--spacing-s);
`;

type HighlightType = "red" | "orange";

export const HighlightTitle = styled.div<{ color: HighlightType }>`
  color: ${(props): string => props.theme.colors.midnight};
  font-style: italic;
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 0.625rem;
  background: ${(props): string => {
    return props.color === "red" ? props.theme.colors["mlb-red"] : props.theme.colors["orange"];
  }};
  width: fit-content;
  padding: 8px;
  border-radius: 10px;
`;

export const EmailContainer = styled.div`
  background-color: ${(props): string => props.theme.colors.midnight};
  color: ${(props): string => props.theme.colors.fog};
  font-size: 0.875rem;
  padding: 0.75rem;
  overflow: scroll;
  max-height: inherit;
`;

export const PlainText = styled.text`
  font-size: 14px;
  color: ${(props): string => props.theme.colors.fog};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const SlLink = styled(Link)`
  color: ${(props): string => props.theme.colors["orange"]} !important;
`;
